import { Button } from '@progress/kendo-react-buttons'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import isEmpty from 'lodash/isEmpty'
import * as React from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app/types'
import * as Breadcrumb from '../../components/breadcrumbs'
import { FlashMessage } from '../../components/flash-message'
import * as IsActive from '../../components/is_active'
import { Loading } from '../../components/loading'
import * as Menu from '../../components/menu/left-nav'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as CommunityConfig from '../community-config'
import * as GridCell from '../grid-cell'
import * as AddEditModal from './add-edit-modal'
import * as Constants from './constants'
import * as GridCells from './grid-cells'
import * as Reducer from './reducer'
import './styles.css'
import * as Types from './types'

const breadcrumbs: Breadcrumb.Breadcrumbs = Menu.breadcrumbs(Menu.CONTENT_LEAD_TEXT_URL)

export interface DispatchProps {
  dispatch: Redux.Dispatch<Redux.Action>,
}
export interface AddLeadTextProps extends DispatchProps {
  enterEdit: AddEditModal.EnterEditActionCreator,
}
export interface Props extends DispatchProps {
  communityConfig?: CommunityConfig.State,
  leadText: Reducer.State,
}

const AddLeadText = ({leadText, dispatch, enterEdit}: AddLeadTextProps & Props) => <span>
  <Button className="secondary-button"
          disabled={leadText.view.isLoading}
          onClick={() => dispatch(enterEdit(Constants.initialLeadText, AddEditModal.GUI_EDITOR) )}
          title="Add">
          Add
  </Button>
  <Button className="secondary-button"
          disabled={leadText.view.isLoading}
          onClick={() => dispatch(enterEdit(Constants.initialLeadText, AddEditModal.RAW_EDITOR))}
          title="Add HTML">
          Add (HTML)
  </Button>
  <AddEditModal.AddEditModal />
  <AddEditModal.RawAddEditModal />
</span>

export const AddLeadTextConnected = connect(
  ({leadText}: ApplicationState) => ({leadText}),
  (dispatch) => ({
    dispatch,
    enterEdit: AddEditModal.enterEdit,
  }),
)(AddLeadText)

export const LeadTextHeader = ({view}: Types.WrappedViewState) => <Row className="margin-auto">
  <Col sm="12" md="10" className="text-left page-header--padding">
    <div className="page-header">
      <span className="title">Lead text</span>
      <AddLeadTextConnected/>
    </div>
  </Col>
  <Col sm="12" md="2">
      <div className="page-header--padding">
        <IsActive.FilterSelect view={view} event={Constants.FETCH_LEAD_TEXT} disabled={view.isLoading}/>
      </div>
    </Col>
</Row>

export const LeadTextGridComponent: React.SFC<Props> = ({communityConfig, leadText, dispatch}) =>
<div className="lead-text-page">
  <Row>
    <Col md="12">
      { leadText.view.isLoading ? <Loading center size={Loading.Sizes.LARGE}/> :
      <Grid data={Request.withDispatch(leadText.data, dispatch)}
            sortable={{
              allowUnsort: true,
              mode: 'multiple',
            }}
            sort={leadText.view.sort}
            onSortChange={(e: GridSortChangeEvent) => dispatch({
                                  options: { value: e.sort },
                                  type: Sortable.sortTableConstant(Constants.FETCH_LEAD_TEXT),
            })}>
        <GridColumn cell={GridCells.ActiveCell} field={AddEditModal.FieldNames.IsActive} title="Status" />
        <GridColumn cell={GridCells.HtmlCell} field={AddEditModal.FieldNames.Description} title="Text" width="500px"/>
        {!isEmpty(communityConfig.partnerCodes) &&
          <GridColumn cell={GridCells.PartnerCode}
                      field={AddEditModal.FieldNames.CommunityPartnerCode}
                      title="Partner Code"
                      width="150" />}
        <GridColumn cell={GridCell.DateCell} field="start_datetime" title="Start Date" />
        <GridColumn cell={GridCell.DateCell} field="end_datetime" title="End Date" />
        <GridColumn cell={GridCell.DateTimeCell} field="updated_datetime" title="Updated" />
      </Grid>}
    </Col>
  </Row>
</div>

export const LeadTextGridConnected = connect(
  ({ leadText, communityConfig }: ApplicationState) => ({ leadText, communityConfig}),
  (dispatch) => ({
    dispatch,
  }),
)(LeadTextGridComponent)

export const LeadTextPage = ({leadText, app}: Types.WrappedState & App.WrappedState) => <div>
  <FlashMessage />
  <Breadcrumb.BreadcrumbComponent breadcrumbs={breadcrumbs}/>
  <LeadTextHeader view={leadText.view}/>
  <LeadTextGridConnected />
</div>

export const LeadTextPageConnected = connect(
  ({leadText, app}: Types.WrappedState & App.WrappedState) => ({leadText, app}),
  (dispatch) => ({dispatch}),
)(LeadTextPage)



// WEBPACK FOOTER //
// ./src/pages/lead-text/component.tsx